import { render } from "./Ternakan.vue?vue&type=template&id=3f6df2ab&scoped=true"
import script from "./Ternakan.vue?vue&type=script&lang=js"
export * from "./Ternakan.vue?vue&type=script&lang=js"

import "./Ternakan.vue?vue&type=style&index=0&id=3f6df2ab&scoped=true&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6df2ab"]])

export default __exports__